module.exports = __webpack_public_path__ + "img/easi-plus.20be81b4.svg";